import * as types from "./mutation_types"
import { setAuthToken } from "@/utils/auth";

export default {
    [types.SHPW_DATA] (state:any,data:{token:string} | null) {
        state.shpwData = data
        if(data&&data.token){
            setAuthToken(data.token)
        }
    },
    [types.PRE_ORDER_DATA] (state:any,data:object) {
        state.preOrderData = data
    },
}
